import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";


export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const res = await axios.post(
        "https://capimusic.synoweberp.in/api/auth/login",
        // "http://localhost:5000/api/auth/login",
        { email, password }
      );

      localStorage.setItem("token", res.data.token);
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + res.data.token;

      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "Invalid Email or Password");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-indigo-700 p-4">
      <div className="bg-white shadow-2xl rounded-2xl p-8 w-full max-w-md relative">

        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img
            src="\assets\logo.png"
            alt="App Logo"
            className="h-14 object-contain"
          />
        </div>

        <h1 className="text-3xl font-extrabold text-gray-800 text-center mb-6">
          Music Admin Login
        </h1>

        {error && (
          <p className="bg-red-100 text-red-600 border border-red-300 rounded-md p-2 mb-4 text-sm text-center">
            {error}
          </p>
        )}

        <form onSubmit={handleLogin}>
          <label className="block mb-2 text-sm font-semibold text-gray-700">
            Email Address
          </label>
          <input
            type="text"
            className="w-full border border-gray-300 rounded-lg p-3 mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your email"
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label className="block mb-2 text-sm font-semibold text-gray-700">
            Password
          </label>
          <input
            type="password"
            className="w-full border border-gray-300 rounded-lg p-3 mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter your password"
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button
            type="submit"
            className="w-full bg-blue-600 hover:bg-blue-700 transition text-white font-semibold py-3 rounded-lg shadow-md"
          >
            Login
          </button>
        </form>

        {/* Branding Footer */}
        <div className="mt-6 text-center text-xs text-gray-500">
          Powered by{" "}
          <span className="font-semibold text-gray-700">
            Synoweb
          </span>
        </div>

      </div>
    </div>
  );
}
